
import en from"./en/en.json";
import es from"./es/es.json";

export var i18nOptions={
resources:{
en:en,
es:es
}
};